import { isToday } from 'date-fns'
import qs from 'qs'
import { useEffect } from 'react'

import commonRepo from '@/repository/common.repo'
import { mixpanelClient } from '@/utils/trackings/mixpanel'
import { convertAcademyAndTeacherToGlobalEventProperty } from '@/utils/trackings/schema/globalEventProperties.schema'
import { convertAcademyToUserProperties } from '@/utils/trackings/schema/userProperties.schema'

export const useDataTracking = () => {
  useEffect(() => {
    if (commonRepo.academy && commonRepo.user) {
      mixpanelClient.identify(commonRepo.academy.academyId)

      mixpanelClient.setGlobalEventProperty({
        ...convertAcademyAndTeacherToGlobalEventProperty({
          academy: commonRepo.academy,
          teacher: commonRepo.user,
        }),
      })

      mixpanelClient.setUserProperty({
        ...convertAcademyToUserProperties({
          academy: commonRepo.academy,
        }),
      })

    }
  }, [commonRepo.academy, commonRepo.user])

  useEffect(() => {
    const params: any = qs.parse(window.location.search, { ignoreQueryPrefix: true })

    if ('s' in params && typeof params.s === 'string') {
      params['당일접속여부'] = isToday(parseInt(params.s))
    }

      }, [])
}
